// extracted by mini-css-extract-plugin
export default {"label_container":"styles_label_container__8jCsq","count":"styles_count__b+t9W"};